// extracted by mini-css-extract-plugin
export default {"container":"cp-z","brandName":"dp-z","productName":"ep-z","productNamePdpEnhancements":"fp-z","breakLongProductName":"gp-z"};